<template>
  <div v-show="loading" class="v-spinner">
    <div class="v-clip" :style="spinnerStyle" />
  </div>
</template>

<script setup lang="ts">
import { computed } from '#imports'

interface Props {
  loading?: boolean
  color?: string
  size?: string
  radius?: string
}

const props = withDefaults(defineProps<Props>(), {
  loading: true,
  color: 'currentColor',
  size: '35px',
  radius: '100%',
})

const spinnerStyle = computed(() => {
  return {
    height: props.size,
    width: props.size,
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: `${props.color} ${props.color} transparent`,
    borderRadius: props.radius,
    background: 'transparent',
  }
})
</script>

<style lang="scss" scoped>
.v-spinner {
  text-align: center;
}

.v-spinner .v-clip {
  animation: v-clipDelay 0.75s 0s infinite linear;
  animation-fill-mode: both;
  display: inline-block;
}
.v-clip {
  margin-bottom: -2px;
}

@-webkit-keyframes v-clipDelay {
  0% {
    -webkit-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
  }
  50% {
    -webkit-transform: rotate(180deg) scale(0.8);
    transform: rotate(180deg) scale(0.8);
  }
  100% {
    -webkit-transform: rotate(360deg) scale(1);
    transform: rotate(360deg) scale(1);
  }
}

@keyframes v-clipDelay {
  0% {
    -webkit-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
  }
  50% {
    -webkit-transform: rotate(180deg) scale(0.8);
    transform: rotate(180deg) scale(0.8);
  }
  100% {
    -webkit-transform: rotate(360deg) scale(1);
    transform: rotate(360deg) scale(1);
  }
}
</style>
